import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverTradeplate from './driver-tradeplate.jsx';

export default class DriversTradeplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_tradeplate_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/tradeplates',
    };


    this.getDriversTradeplates();
  }

  getDriversTradeplates() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_tradeplate_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversTradeplates = [];

    if (this.state.drivers_tradeplate_accounts &&
        this.state.drivers_tradeplate_accounts.length > 0) {
        this.state.drivers_tradeplate_accounts.forEach(
          function(i) {
            DriversTradeplates.push(
              <DriverTradeplate
                key={'drivers-tradeplates-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversTradeplates}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-tradeplates')) {
  ReactDOM.render(
    <DriversTradeplates
      url = {"/api/v1/portal/drivers/tradeplates"}
      message_if_none = 'Trade plate renatals not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-tradeplates'
    )
  );
}
